export default __webpack_public_path__ + "static/media/gauge.d0718c76.webp";